import { Component } from "react";
import ReactTable from "./ReactTable";
import "./Table.css";
import "../../utils.css";
import classnames from "classnames";

class TableWithoutPagination extends Component {
    render() {
        return (
            <div
                className={classnames(
                    "col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding",
                    this.props.className
                )}
            >
                <ReactTable
                    {...this.props}
                    defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
                    minRows={this.props.minRows !== undefined ? this.props.minRows : 10}
                    defaultPageSize={this.props.defaultPageSize !== undefined ? this.props.defaultPageSize : 100}
                    pageSize={this.props.pageSize !== undefined ? this.props.pageSize : 100}
                    showPagination={this.props.showPagination !== undefined ? this.props.showPagination : false}
                    previousText="Précédent"
                    nextText="Suivant"
                    loadingText="Chargement..."
                    noDataText="Aucun résultat"
                    pageText="Page"
                    ofText="sur"
                    rowsText="lignes"
                    className="-striped col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
                    style={{
                        height: "100%", // This will force the table body to overflow and scroll, since there is not enough room
                    }}
                />
            </div>
        );
    }
}

export default TableWithoutPagination;
